<template>
  <div class="contact-us-component">
    <div class="contact-us text-center">
      <div class="container d-none d-lg-block">
        <div class="row">
          <div class="col-12">
            <div class="reseller">
              <h2>Become a Dutché Reseller!</h2>
              <p>If you would like to know how you can become one of our resellers, <br/> contact us through the following:</p>
              <div class="container">
                <div class="row">
                  <div class="col-12" style="margin-top:7rem">
                    <a href="tel:+639228636675" class="btn btn-block btn-dutche-violet">
                      <strong>Call +63 922 863 6675</strong>
                    </a>
                    <a href="/find-us#contact-form" class="btn btn-block btn-dutche-violet">
                      <strong>Send us an email</strong>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-block d-lg-none">
        <div class="row">
          <div class="col-12">
            <div class="reseller">
              <h2>Become a Dutche <br> Reseller!</h2>
              <p class="mt-4">If you would like to know how you can become one of our resellers, <br/> contact us through the following:</p>
              <div class="row mt-5">
                <div class="col-12">
                  <a href="tel:+639228636675" class="btn btn-block btn-dutche-violet">
                    <strong>Call +63 922 863 6675</strong>
                  </a>
                  <a href="/find-us" class="btn btn-block btn-dutche-violet mt-3">
                    <strong>Send us an email</strong>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
};
</script>

<style lang="sass" scoped>
.contact-us-component
  margin: 5rem auto

  .contact-us
    background-image: url('../../assets/images/home/reseller.jpg')
    background-size: cover
    background-color: #ddd
    background-position: center bottom
    padding: 3rem 2rem
    height: 30rem

  .reseller
    margin-top: 2em

  .btn-dutche-violet
    text-transform: uppercase
    border-radius: 0.5rem
    background-color: $dutche-primary-violet
    color: $white
    padding: 0.5rem 1rem
    max-width: 350px
    display: inline-block
    margin: 0 15px

  .btn-dutche-violet:hover
    color: $dutche-primary-yellow

  h2
    font-family: "Might Could"
    font-weight: bold
    font-size: 2.5em

  p
    font-size: 0.9em

@media (max-width: 575px)
  .contact-us-component
    margin: 4rem auto

@media (min-width: 786px)
  .contact-us-component
    h2
      font-size: 5em

    .btn-dutche-violet
      padding: 1rem 2rem

    p
      font-size: 1em

</style>
